<div class="overview-container">
    <!-- Header Section -->
    <div class="overview-header">
        <h2>Overview</h2>
    </div>


    <!-- Active Items Grid -->
    <div class="active-items-grid" *ngIf="activeItems.length > 0; else noActiveItems">
        <div class="active-item-card" *ngFor="let item of activeItems">
            <!-- Reuse Common View Component -->
            <app-common-sourcing-view [title]="item.name" [emoji]="item.emoji" [image]="item.image" [data]="item.data"
                [config]="getViewConfig(item.type)" [readOnly]="true" [isOverview]="true">
            </app-common-sourcing-view>
        </div>
    </div>

    <!-- Empty State -->
    <ng-template #noActiveItems>
        <div class="no-active-items">
            <div class="empty-icon">
                <i nz-icon nzType="inbox" nzTheme="outline" style="font-size: 64px; color: #bfbfbf;"></i>
            </div>
            <h3>No Active Components</h3>
            <p>Please enable at least one option to see the overview.</p>
        </div>
    </ng-template>

</div>